/**
 * Privacy disclaimer shown above the contract upload action buttons.
 *
 * Pure presentation component — message text comes from the
 * `CONTRACT_PRIVACY_DISCLAIMER` constant so the wording stays
 * consistent if it has to change.
 * @module features/contracts/components/PrivacyDisclaimer/PrivacyDisclaimerView
 */

import { Lock } from "lucide-react-native";
import React, { memo } from "react";

import { CONTRACT_PRIVACY_DISCLAIMER } from "@/features/contracts/constants";

import { Box } from "@/components/atoms/Box";
import { Stack } from "@/components/atoms/Stack";
import { Icon } from "@/components/atoms/Icon";
import { Text } from "@/components/atoms/Text";

/**
 * Renders the contract upload privacy disclaimer.
 * @returns A locked-icon row with the privacy reminder text
 */
const PrivacyDisclaimerView = () => (
  <Box testID="contract-privacy-disclaimer">
    <Stack
      direction="horizontal"
      className="items-start gap-2 rounded-none bg-surface-info-subtle p-3"
    >
      <Icon
        as={Lock}
        size="sm"
        className="mt-micro text-needs-semantic-info-700"
      />
      <Text variant="caption" className="flex-1 text-needs-semantic-info-700">
        {CONTRACT_PRIVACY_DISCLAIMER}
      </Text>
    </Stack>
  </Box>
);

PrivacyDisclaimerView.displayName = "PrivacyDisclaimerView";

export default memo(PrivacyDisclaimerView);
